import { atom } from 'jotai';

export const loadingAtom = atom(false);
loadingAtom.debugLabel = 'loadingAtom';
